import React from 'react';
import './Dashboard.css';

const maskMobile = (number) => {
  if (!number || number.length < 4) return number;
  return number.slice(0, 5) + '*****' + number.slice(-2);
};

const ReferralLeadsDashboard = ({ leadReferrals = [] }) => {
  return (
    <div className="referral-section">
      <h3 className="referral-subtitle">🏠 Property Referral Leads</h3>
      {leadReferrals.length === 0 ? (
        <p className="no-referrals-text">No property leads referred yet.</p>
      ) : (
        <div className="referral-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Intent</th>
                <th>Lead Status</th>
                <th>Site Visit</th>
                <th>Deal Closure</th>
              </tr>
            </thead>
            <tbody>
              {leadReferrals.map((lead) => (
                <tr key={lead.id}>
                  <td data-label="Name">{lead.name}</td>
                  <td data-label="Mobile">{maskMobile(lead.mobile)}</td>
                  <td data-label="Intent">{lead.intent}</td>
                  <td data-label="Lead Status">
                    {lead.lead_verification || 'Pending'}
                  </td>
                  <td data-label="Site Visit">
                    {lead.reward_site_visit === 'granted' ? '✅ Done' : 'Pending'}
                  </td>
                  <td data-label="Deal Closure">
                    {lead.reward_deal_closure === 'granted' ? '✅ Done' : 'Pending'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ReferralLeadsDashboard;
